// bottom -> top layers: 1.) floors 2.) collision blocks 3.) chairs decor

const layers = [
  [
    12, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33,
    33, 33, 32, 4, 18, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25,
    25, 25, 25, 25, 24, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19,
    28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4,
    17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 3, 3, 19, 28, 4, 17, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    3, 19, 28, 4, 16, 10, 10, 10, 10, 10, 10, 10, 17, 3, 3, 19, 10, 10, 10, 10,
    10, 10, 10, 11, 28, 27, 26, 26, 26, 26, 26, 26, 26, 26, 16, 10, 10, 11, 26,
    26, 26, 26, 26, 26, 26, 26, 20
  ],
  [
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, 15, 55, 55, 55, 55, 55, 55, 55, 51, 55, 55, 55, 55, 55, 55,
    55, 55, 55, 55, 47, -1, -1, 7, 35, 13, 36, 36, 34, 5, 0, 38, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, 0, 7, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, 22, -1, -1, 7, -1, -1, 7, 0, -1, -1, 6, -1,
    -1, -1, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7, 43, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7,
    42, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7,
    -1, -1, 7, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, 7, -1, -1, 50, 55, 55, 55, 55, 48, -1, -1, 49, -1, -1, -1, 37, 44,
    -1, 37, 44, -1, -1, 7, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, 7, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7, -1, -1, -1, -1, -1, -1,
    -1, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7, -1, -1, -1, -1,
    -1, -1, -1, 7, -1, -1, -1, 37, 44, -1, 37, 44, -1, -1, 7, -1, -1, 7, -1, -1,
    -1, -1, -1, -1, -1, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 7,
    -1, -1, -1, -1, -1, -1, -1, 7, -1, -1, 0, -1, -1, -1, -1, -1, -1, 0, 7, -1,
    -1, 54, 55, 55, 55, 55, 55, 55, 55, 52, -1, -1, 15, 55, 55, 55, 55, 55, 55,
    55, 31, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 54, 55, 55, 31, -1, -1, -1,
    -1, -1, -1, -1, -1, -1
  ],
  [
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 21, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1,
    1, -1, 1, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, 29, -1, -1, -1, -1, 21, -1, -1, -1, -1, -1, 29,
    -1, -1, -1, -1, 2, 2, -1, 2, 2, -1, -1, -1, -1, -1, -1, -1, 9, 9, 9, 9, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 9, 9,
    9, -1, -1, -1, -1, -1, -1, 1, 1, -1, 1, 1, -1, -1, -1, -1, -1, -1, -1, 9, 9,
    9, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 29, -1, -1, -1, -1, -1,
    9, 9, 9, 9, -1, -1, -1, -1, -1, -1, 2, 2, -1, 2, 2, -1, -1, -1, -1, -1, -1,
    21, -1, -1, -1, -1, -1, 29, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1
  ],
  [
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-5,-5,-5,-1,-1,-1,
    -1,-1,-1,-1,-3,-3,-3,-1,-4,-4,-4,-1,-1,-1,-1,-1,-5,-5,-5,-1,-1,-1,
    -1,-1,-2,-2,-3,-3,-3,-1,-4,-4,-4,-1,-1,-1,-1,-1,-5,-5,-5,-1,-1,-1,
    -1,-1,-2,-2,-3,-3,-3,-1,-4,-4,-4,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-2,-2,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-2,-2,-1,-1,-1,-1,-1,-1,-1,-1,-1,-7,-7,-1,-8,-8,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-7,-7,-1,-8,-8,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-7,-7,-1,-8,-8,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-9,-9,-1,-10,-10,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-9,-9,-1,-10,-10,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-9,-9,-1,-10,-10,-1,-1,-1,-1,
    -1,-1,-6,-6,-6,-6,-6,-6,-6,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
    -1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1

  ]
]

// -3 near piano table
// -4 right kitchen table
// -5 top right table
// -2 piano
// -6 conference
// -7, -8, -9, -10 clock wise from top left

export default layers;